/*jshint esversion: 6 */

// Website Components
// import {SomeComponent} from './components/some-component';

// Collections
// import {SomeColection} from './collections/some-collection';

// Models
// import {SomeModel} from './models/some-model';


// Forked from: 
// https://css-tricks.com/the-complete-guide-to-lazy-loading-images/
document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }
  
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);

  lazyload();

});


document.addEventListener("DOMContentLoaded", function() {

  let thumbsEl = document.getElementsByClassName('gallery-thumbs')[0];
  let sliderEl = document.getElementsByClassName('gallery-top')[0];

if(thumbsEl)
  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 3,
    loop: false,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,

    breakpoints: {
      640: {
        slidesPerView: 4,
        spaceBetween: 210,
      },
      768: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 10,
        spaceBetween: 10,
      },
    }

  });

if(sliderEl)
  var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    loop: true,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });

});

// if(id_exists("some-component"))
// 	window.SomeComponent = new SomeComponent().$mount('#some-component');
